/* istanbul ignore file */

import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { App } from './App';
import { ThemeProvider } from '@emotion/react';
import theme from './theme';
import { SnackbarProvider } from './hooks/snackbar.hook';
import { ConfirmProvider } from 'material-ui-confirm';
import { CookieUi } from './components/user-interfaces/cookie/cookie.ui';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <SnackbarProvider>
                <CookieUi />
                <ConfirmProvider>
                    <RouterProvider router={App} />
                </ConfirmProvider>
            </SnackbarProvider>
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
